import { z } from "zod";
import { RequestTypeOdvetvieDtoSchema } from "./RequestTypeOdvetvieDto";

export const RequestTypeDtoSchema = z.object({
    id: z.number(),
    name: z.string().nullish(),
    icon: z.string().nullish(),
    reactIcon: z.string().nullish(),
    iconColor: z.string().nullish(),
    description: z.string().nullish(),
    canUploadFiles: z.boolean(),
    attachmentsRequired: z.boolean(),
    defaultDocumentTaxonomyId: z.number().nullish(),
    order: z.number().nullish(),
    odvetvia: z.array(RequestTypeOdvetvieDtoSchema),
});

export type RequestTypeDto = z.infer<typeof RequestTypeDtoSchema>;